import {Fragment, useState} from 'react'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import SettingsIcon from '@mui/icons-material/SettingsSuggest'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import ClientForm from './ClientForm'
import DeleteClient from './DeleteClient'
import Modal from '../../shared/Modal'
import NewClientController from './NewClientController'

import {connect} from '../../../state/hooks/tools'
import {CLIENTS} from '../../../state/actionTypes'
import {updateResource} from '../../../lib/asyncMethods'
import {findRecordByAttribute} from '../../../lib/data'

import './clients.scss'

const Clients = props => {
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [data, setData] = useState({})
  const [showDelete, setShowDelete] = useState(false)
  const [clientToDelete, setClientToDelete] = useState({})

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const toggleEditModal = () => {
    setShowEditModal(!showEditModal)
  }

  const edit = id => () => {
    const client = findRecordByAttribute({records: props.clients, attribute: 'id', id})

    setData(client)
    toggleEditModal()
  }

  const handleSubmit = data => {
    props.updateResource({endpoint: `clients/${data.id}`, attributes: data}).then(response => {
      if (response.success)
        toggleEditModal()
    })
  }

  const toggleDelete = () => {
    setShowDelete(!showDelete)
  }

  const confirmDelete = client => () => {
    setClientToDelete(client)
    toggleDelete()
  }

  return (
    <Fragment>
      <Stack className='clients'>
        <Stack sx={{flexDirection: 'row', justifyContent: 'space-between'}}>
          <Stack className='label' sx={{flexDirection: 'row'}}>
            <SettingsIcon fontSize='large' />
            <Typography variant='h5'>Clients</Typography>
          </Stack>
          <Button onClick={toggleModal}>New Client</Button>
        </Stack>
        <Divider />
        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}} sx={{marginTop: '15px'}}>
          {
            props.clients.map(client => (
              <Grid key={client.id} size={6}>
                <Card sx={{bgcolor: 'Background'}}>
                  <CardHeader component='h6' title={client.name} />
                  <Divider />
                  <CardContent>
                    <Typography variant='body1'>{client.description}</Typography>
                  </CardContent>
                  <CardActions>
                    <IconButton onClick={edit(client.id)} aria-label='edit' color='primary'>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={confirmDelete(client)} color='error' aria-label='destroy'>
                      <DeleteIcon />
                    </IconButton>
                  </CardActions>
                </Card>
              </Grid>
            ))
          }
        </Grid>
      </Stack>
      <NewClientController loading={props.loading} showModal={showModal} toggleModal={toggleModal} />
      <Modal
        open={showEditModal}
        handleClose={toggleEditModal}
        disabled={props.loading}
        subHeading='Information about connected client services.'
        buttonText='Done'
        title='Edit Client'>
          <ClientForm data={data} handleSubmit={handleSubmit} />
      </Modal>
      <DeleteClient showModal={showDelete} toggleModal={toggleDelete} client={clientToDelete} />
    </Fragment>
  )
}

const mapStateToProps = ({clients}) => ({clients: [], ...clients})

const actionCreators = ({clients}) => ({
  updateResource: updateResource(clients, CLIENTS)
})

export default connect(mapStateToProps, actionCreators)(Clients)
